import * as moment from 'moment';

export default {
  calculateMilitaryTime(val, isStart) {
    const [time, period] = val.split(' ');
    const [hours, minutes] = time.split(':');
    // const militaryHours = period === 'PM' && Number(hours) !== 12 ? Number(hours) + 12 : hours;
    let militaryHours = Number(hours);
    // if period is PM
    if (period === 'PM' && Number(hours) !== 12) {
      // if number is not 12, add 12 to get military time
      militaryHours += 12;
    } else if (period === 'AM' && Number(hours) === 12) {
      militaryHours = 0;
      // if it is 12am and end time, then it is the end of the day
      // if minutes are greater than 0, then it is the start of the day
      if (!isStart && minutes === '00') {
        militaryHours = 24;
      }
    }
    return `${militaryHours}:${minutes}:00`;
  },
  pad(num, size) {
    const s = num.toString().split('');
    while (s.length < size) s.unshift('0');
    return s.join('');
  },
  convertTimeToMinutes(time, isStart) {
    let hours = time.split(':')[0];
    const mins = time.split(':')[1];
    if (!isStart && (Number(hours) === 0) && Number(mins) === 0) hours = 24;
    return (Number(hours) * 60) + Number(mins);
  },
  calculateMilitaryTimeFromMinutes(val, endTime) {
    let hours = Math.floor(val / 60);
    const minutes = val % 60;
    // if the time is greater than 24:00, then its invalid
    if (hours > 24 && minutes > 0) throw new Error('Invalid Time');
    // if hours is 24 and we are calculating end time, set hours to 0 for midnight
    if (hours === 24 && endTime) hours = 0;
    return `${this.pad(hours, 2)}:${this.pad(minutes, 2)}`;
  },
  calculateStartTime(endTime, elapsedTime) {
    const endTimeInMinutes = this.convertTimeToMinutes(endTime, false);
    const startTimeInMinutes = endTimeInMinutes - Number(elapsedTime);
    if (startTimeInMinutes < 0) throw new Error('Start Time must be earlier than End Time.');
    return this.calculateMilitaryTimeFromMinutes(startTimeInMinutes);
  },
  calculateEndTime(startTime, elapsedTime) {
    // convert start time to minutes
    const startTimeInMinutes = this.convertTimeToMinutes(startTime, true);
    return this.calculateMilitaryTimeFromMinutes(startTimeInMinutes + Number(elapsedTime), true);
  },
  calculateServiceLength(startTime, endTime) {
    const startTimeInMinutes = this.convertTimeToMinutes(startTime, true);
    const endTimeInMinutes = this.convertTimeToMinutes(endTime, false);
    // 1440 = 24 hours * 60 minutes
    // end time can't exceed 12AM
    return endTimeInMinutes - startTimeInMinutes;
  },
  formatDate(date) {
    if (!date) return null;
    return moment(date, 'YYYY-MM-DD').format('MM-DD-YYYY');
  },
  addSubmission(sub) {
    // submission is the array in local storage or an empty array
    const allSubmissions = JSON.parse(localStorage.getItem('submission-array')) || [];
    // checks if the submission is already in the array (editing a SL)
    const exists = allSubmissions.filter((submission) => {
      return submission.sessionId === sub.sessionId;
    });
    // if the submission isn't in the array, put it in
    if (!exists.length) allSubmissions.push(sub);
    localStorage.setItem('submission-array', JSON.stringify(allSubmissions));
  },
  copySubmission(sub) {
    // submission is the array in local storage or an empty array
    const allSubmissions = JSON.parse(localStorage.getItem('submission-array')) || [];
    // checks if the submission is already in the array (editing a SL)
    const exists = allSubmissions.filter((submission) => {
      return submission.sessionId === sub.sessionId;
    });
    // if the submission isn't in the array, put it in
    if (!exists.length) allSubmissions.push(sub);
    localStorage.setItem('submission-array', JSON.stringify(allSubmissions));

    const length = allSubmissions.length - 1;
    return allSubmissions[length].sessionId;
  },
  clearSubmissionArray() {
    localStorage.removeItem('submission-array');
  }
};



// WEBPACK FOOTER //
// ./src/utils/functions.js